// Custom JS imports
import { runNav } from '../js/index.js';

runNav();

// Custom CSS imports
import '../sass/main.scss';